var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap", "align-items": "center" },
              attrs: { justify: "start", type: "flex" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "日期 Data" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "90%" },
                        attrs: {
                          clearable: false,
                          "end-placeholder": _vm.$t("collectionCenter.EndTime"),
                          "range-separator": _vm.$t("collectionCenter.to"),
                          "start-placeholder": _vm.$t(
                            "collectionCenter.StartTime"
                          ),
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.dateChange },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "大区 Região" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "90%" },
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                          },
                          on: { change: _vm.regionChange },
                          model: {
                            value: _vm.queryForm.params.regionId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "regionId", $$v)
                            },
                            expression: "queryForm.params.regionId",
                          },
                        },
                        _vm._l(_vm.regionList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.zhName + "（" + item.puName + "）",
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "网点所属州 Estado do ponto" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "90%" },
                          attrs: {
                            placeholder: _vm.$t("placeOrder.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryForm.params.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "state", $$v)
                            },
                            expression: "queryForm.params.state",
                          },
                        },
                        _vm._l(_vm.stateOptionList, function (item, idx) {
                          return _c("el-option", {
                            key: idx,
                            attrs: {
                              label: item.shortName,
                              value: item.shortName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-search",
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.searchClick },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-refresh-left",
                        size: "small",
                        type: "info",
                      },
                      on: { click: _vm.defaultClick },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "primary" },
          on: { click: _vm.exportClick },
        },
        [_vm._v(_vm._s(_vm.$t("newOrder.export")))]
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "10px" },
          attrs: {
            data: _vm.processedTableData,
            "span-method": _vm.objectSpanMethod,
            border: "",
          },
        },
        _vm._l(_vm.tableColumns, function (column) {
          return _c("el-table-column", {
            key: column.prop,
            attrs: {
              label: column.label,
              prop: column.prop,
              width: column.width,
              align: "center",
              "header-align": "center",
            },
          })
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [100, 200, 400, 500, 1000],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.searchClick1,
              "size-change": _vm.searchClick,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }